import { render, staticRenderFns } from "./wcTabbarCart.vue?vue&type=template&id=29ee82ae"
import script from "./wcTabbarCart.vue?vue&type=script&lang=js"
export * from "./wcTabbarCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports